<template>
  <div>
    <slotModal
      :id-modal="'namaUser'"
      :modal-title="'Ubah Nama'"
      v-model="dialog"
      @close="close"
    >
      <template v-slot:modal-content>
        <div class="p-x-20">
          <p class="f-Overpass f-14 f-w-400 m-0 p-t-10 p-b-10 f-c-black">
            Ubah nama yang tertera pada akun anda
          </p>

          <div>
            <p class="f-Overpass f-14 f-w-400 m-0">
              Nama <span class="required">*</span>
            </p>
            <input
              type="text"
              class="form-control f-16 f-Overpass f-w-400"
              v-model="nama"
            />
          </div>
          <div class="p-t-20 p-b-20">
            <button
              class="btn btn-primary f-Overpass w-100"
              :disabled="calculateKata(nama) < 2 ? true : false"
              @click="handleSubmit"
            >
              Simpan
            </button>
          </div>
        </div>
      </template>
    </slotModal>
  </div>
</template>

<script>
import slotModal from "@/components/slots/slotModal.vue";
import { mapActions, mapState } from "vuex";

export default {
  name: "nomorWhatsApp",
  components: {
    slotModal,
  },
  props: ["namaSet"],

  data() {
    return {
      dialog: false,
      nama: "",
    };
  },
  computed: {
    ...mapState("akun", {
      namaUser: "namaUser",
    }),
  },
  methods: {
    ...mapActions({
      getIdUser: "akun/getIdUser",
      postChangeName: "akun/postChangeName",
      getDataAkun: "akun/getDataAkun",
    }),
    name() {
      return this.namaSet;
    },
    open() {
      this.dialog = true;
    },

    close() {
      this.dialog = false;
    },

    async handleSubmit() {
      let body = {
        nama: this.nama,
      };

      await this.postChangeName(body).then((res) => {
        if (res.status == 200) {
          this.$toast.success("Nama Berhasil Di Ubah", { position: "top" });
          this.close();
          if (this.dialog == false) {
            this.getIdUser().then((res) => {
              if (res.status == 200) {
                let idUser = res.data.customer_global.id;
                this.getDataAkun(idUser);
              }
            });
          }
        }
      });
    },

    calculateKata(text) {
      let textData = text.trim();
      let textArray = textData.split(/\s+/);
      return textArray.length;
    },
  },
};
</script>
